export default "__VITE_PUBLIC_ASSET__c4b4d87d__"